// extracted by mini-css-extract-plugin
module.exports = {"container":"ViewBlock_container__1m9mb","text":"ViewBlock_text__1ZoOZ"};